// extracted by mini-css-extract-plugin
module.exports = {"gridViewContainer":"styles_gridViewContainer__1wnIY","captureWorkButton":"styles_captureWorkButton__1OeTo","cameraIcon":"styles_cameraIcon__2e-RH"};